"use client";

import { TeamId } from "@/constants/type";
import { useRouter, useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = { targetTeam: TeamId };

function CheckBox({ targetTeam }: { targetTeam: TeamId }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const league = searchParams.get("league");
  const team = searchParams.get("team");
  const params = new URLSearchParams(searchParams.toString());

  const isChecked = (() => {
    if (typeof team === "string" && team?.split(",").includes(targetTeam)) return true;
    else if (league === "セ") return ["C", "D", "G", "S", "T", "Y"].some((s) => s === targetTeam);
    else if (league === "パ") return ["B", "E", "F", "H", "L", "M"].some((s) => s === targetTeam);
    return false;
  })();

  const setTeamCheckBox = (t: TeamId) => {
    if (isChecked) {
      const hasSelectedTeam = team?.split(",").includes(t);
      const deleteSelectedTeam = (t: TeamId) => {
        const teamArray = team?.split(",").filter((f) => f !== t) ?? [];
        teamArray.length === 0 ? params.delete("team") : params.set("team", teamArray.join(","));
      };
      const deleteTeamFromLeague = (t: TeamId) => {
        const l = league === "セ" ? ["C", "D", "G", "S", "T", "Y"] : ["B", "E", "F", "H", "L", "M"];
        const teamArray = (l as readonly TeamId[]).filter((f) => f !== t);
        params.set("team", teamArray.join(","));
        params.delete("league");
      };
      hasSelectedTeam ? deleteSelectedTeam(t) : deleteTeamFromLeague(t);
    } else {
      const hasTeamParam = params.has("team");
      hasTeamParam ? params.set("team", `${team},${t}`) : params.set("team", t);
    }
    router.replace("?" + params.toString(), { scroll: false });
  };
  return (
    <input
      className="checkbox checkbox-sm checkbox-primary border-secondary group-hover/team:border-primary"
      type="checkbox"
      onChange={() => setTeamCheckBox(targetTeam)}
      checked={isChecked}
    />
  );
}
export default function TeamsCheckBox(props: Props) {
  return (
    <Suspense
      fallback={
        <input
          className="checkbox checkbox-sm checkbox-primary border-secondary group-hover/team:border-primary"
          type="checkbox"
        />
      }
    >
      <CheckBox {...props} />
    </Suspense>
  );
}
